const ApplicationsIcon = () => {
  return (
    <svg
      className="animate-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 107.34 107.34"
      shapeRendering="geometricPrecision"
      style={{
        position: 'absolute',
        width: '107px',
        height: '107px',
        bottom: -5,
        right: -9,
        transition: 'opacity 0.25s ease-in-out',
      }}
    >
      <rect
        className="animate-app-tl"
        x="1"
        y="1"
        width="44.6702"
        height="44.6702"
        rx="3"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <rect
        className="animate-app-tr"
        x="61.6702"
        y="1"
        width="44.6702"
        height="44.6702"
        rx="3"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <rect
        className="animate-app-bl"
        x="1"
        y="61.6702"
        width="44.6702"
        height="44.6702"
        rx="3"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <circle
        className="animate-app-br"
        cx="84.0053"
        cy="84.0053"
        r="22.3351"
        fill="#5bd992"
        stroke="#2d426a"
        strokeWidth={2}
      />
    </svg>
  );
};

export default ApplicationsIcon;
